<template>
  <div>
    <XVactionbar>
      <template slot="actionbuttons">
        <button
          type="button"
          id="btnToevoegen"
          class="btn btn-primary btn-xs"
          @click.prevent="btnToevoegen"
          v-if="role.schoolleider"
        >
          <font-awesome-icon icon="plus" />
          {{ translation(16843) }}
        </button>
        <button
          type="button"
          id="btnBericht"
          class="btn btn-primary btn-xs"
          @click.prevent="btnBericht"
          v-if="role.bestuurder"
        >
          <font-awesome-icon icon="plus" />
          {{ translation(16874) }}
        </button>
      </template>
    </XVactionbar>
    <div class="row">
      <div class="col-12">
        <span id="lblTitel" class="titel">{{ translation(16841) }}</span>
      </div>
    </div>
    <div class="row lblBeschrijving" v-if="translation(16842) !== ''">
      <div class="col-12">
        <p v-html="translation(16842)"></p>
      </div>
    </div>
    <div v-if="translation(extraInformationTranslationKey) !== ''">
      <div>
        <p v-html="translation(extraInformationTranslationKey)"></p>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <XVfilter v-if="role.beheerder && !loading">
          <div slot="content">
            <div class="margin20">
              <XVbootstraprow :label="translation(16878)" id="filterBestuurRow">
                <XVinput
                  id="filterBestuur"
                  key="filterBestuur"
                  name="filterBestuur"
                  v-model="filterInput.bestuur"
                  type="text"
                ></XVinput>
              </XVbootstraprow>
              <XVbootstraprow :label="translation(16889)" id="filterRegisteredRow">
                <XVinput
                  id="filterRegistered"
                  key="filterRegistered"
                  name="filterRegistered"
                  v-model="filterInput.registered"
                  type="text"
                ></XVinput>
              </XVbootstraprow>
              <XVbootstraprow
                :label="translation(19783)"
                id="filterGebDatumRow"
                :haserror="errors.has('tbxGebDatum')"
                :errormessage="errors.first('tbxGebDatum')"
              >
                <XVdate
                  id="tbxGebDatum"
                  key="tbxGebDatum"
                  name="tbxGebDatum"
                  :data-vv-as="translation(19783)"
                  v-validate="{ XVDateDefault: true }"
                  v-model.trim="filterInput.iBirthDate"
                ></XVdate>
              </XVbootstraprow>
            </div>
          </div>
          <span slot="filterbuttons">
            <div>
              <div class="btn-group XVSearchbarFilter">
                <button
                  @click="resetFilters"
                  :disabled="!filterHasText"
                  :class="[!filterHasText ? 'disabled filter-disabled' : 'btn-primary', 'btn XVSearchbarButton']"
                >
                  {{ translation(8835) }}
                  <font-awesome-icon icon="eraser" />
                </button>
                <button
                  id="btnFilter"
                  :disabled="errors.items.length > 0"
                  class="btn btn-primary XVSearchbarButton"
                  @click="filterResults()"
                >
                  {{ translation(18831) }}
                  <i class="fa fa-search "></i>
                </button>
              </div>
            </div>
          </span>
        </XVfilter>
        <XVtableV2
          :filterfunc="filterfunc"
          :tablesetting="srpoTable.tablesetting"
          :tablecolumnsetting="srpoTable.tablecolumnsetting"
          :tabledata="srpoTable.tabledata"
          v-on:sortXVTable="XVTablesort"
          :XVtableSetRowStateProperty="XVtableSetRowStateProperty"
          :tableSearchBox="false"
          :class="{ margin50bottom: !role.bestuurder }"
          v-if="!loading"
        >
          <template slot="bestuur" slot-scope="dr">
            {{ dr.celldata + ' (' + dr.row.bevoegdGezagNummer + ')' }}
          </template>
          <template slot="wijzig" slot-scope="dr">
            <span
              :id="'wijzig_' + [dr.index]"
              :title="translation(16844)"
              v-if="dr.row.einddatum === ''"
              @click="wijzigPersoon(dr)"
            >
              <font-awesome-icon
                :icon="['far', 'calendar-edit']"
                class="initial pointer"
                v-bind:class="{ hideIcon: dr.row.tableRowState.editModus }"
              />
              <font-awesome-icon
                icon="chevron-up"
                class="initial pointer"
                v-bind:class="{ hideIcon: !dr.row.tableRowState.editModus }"
              />
            </span>
          </template>
          <template slot="verwijder" slot-scope="dr">
            <span :id="'verwijder_' + [dr.index]" @click="openConfirmVerwijder(dr)" :title="translation(16845)">
              <font-awesome-icon :icon="['fa', 'trash']" class="initial pointer" />
            </span>
          </template>
          <template slot="vestiging" slot-scope="dr">
            <span>{{ dr.row.tableRowState.vestigingString }}</span>
          </template>
          <template slot="detailrow" slot-scope="tablerow">
            <div class="margin20" v-if="role.bestuurder">
              <div class="row" v-if="wXS || wSM || wMD">
                <div class="col-4 col-sm-12 col-xs-12">
                  <label>{{ translation(16888) }}</label>
                </div>
                <div class="col-8 col-sm-12 col-xs-12 form-group has-feedback">{{ tablerow.row.status }}</div>
              </div>
              <div class="row" v-if="wXS || wSM || wMD">
                <div class="col-4 col-sm-12 col-xs-12">
                  <label>{{ translation(16890) }}</label>
                </div>
                <div class="col-8 col-sm-12 col-xs-12 form-group has-feedback">
                  {{ tablerow.row.herregistratiedatum }}
                </div>
              </div>
              <div class="row" v-if="wXS || wSM || wMD">
                <div class="col-4 col-sm-12 col-xs-12">
                  <label>{{ translation(16869) }}</label>
                </div>
                <div class="col-8 col-sm-12 col-xs-12 form-group has-feedback">{{ tablerow.row.geboortedatum }}</div>
              </div>
              <div class="row" v-if="wXS || wSM || wMD">
                <div class="col-4 col-sm-12 col-xs-12">
                  <label>{{ translation(16868) }}</label>
                </div>
                <div class="col-8 col-sm-12 col-xs-12 form-group has-feedback">{{ tablerow.row.email }}</div>
              </div>
              <div class="row" v-if="wXS || wSM || wMD">
                <div class="col-4 col-sm-12 col-xs-12">
                  <label>{{ translation(16846) }}</label>
                </div>
                <div class="col-8 col-sm-12 col-xs-12 form-group has-feedback">{{ tablerow.row.startDatum }}</div>
              </div>
              <div class="row" v-if="wXS || wSM || wMD">
                <div class="col-4 col-sm-12 col-xs-12">
                  <label>{{ translation(16849) }}</label>
                </div>
                <div class="col-8 col-sm-12 col-xs-12 form-group has-feedback">
                  {{ tablerow.row.tableRowState.vestigingString }}
                </div>
              </div>
            </div>
            <!-- detailrow schoolleider of beheerder -->
            <div class="margin20" v-if="role.schoolleider || role.beheerder">
              <div class="margin20bottom">
                <div class="row" v-if="wXS || wSM">
                  <div class="col-4 col-sm-12 col-xs-12">
                    <label>{{ translation(16846) }}</label>
                  </div>
                  <div class="col-8 col-sm-12 col-xs-12 form-group has-feedback">{{ tablerow.row.startDatum }}</div>
                </div>
                <div class="row" v-if="(wXS || wSM) && tablerow.row.einddatum !== ''">
                  <div class="col-4 col-sm-12 col-xs-12">
                    <label>{{ translation(16847) }}</label>
                  </div>
                  <div class="col-8 col-sm-12 col-xs-12 form-group has-feedback">{{ tablerow.row.einddatum }}</div>
                </div>
                <div class="row" v-if="role.beheerder && (wXS || wSM || wMD)">
                  <div class="col-md-4 col-sm-12 col-xs-12">
                    <label>{{ translation(16869) }}</label>
                  </div>
                  <div class="col-8 col-sm-12 col-xs-12 form-group has-feedback">{{ tablerow.row.geboortedatum }}</div>
                </div>
                <div class="row" v-if="wXS || wSM || wMD">
                  <div class="col-md-4 col-sm-12 col-xs-12">
                    <label>{{ translation(16848) }}</label>
                  </div>
                  <div
                    class="col-8 col-sm-12 col-xs-12 form-group has-feedback"
                    v-if="tablerow.row.tableRowState.vestigingString !== ''"
                  >
                    {{ tablerow.row.tableRowState.vestigingString }}
                  </div>
                </div>
              </div>
              <div
                class="XVtablewijzigen"
                v-if="tablerow.row.tableRowState.editModus && (role.schoolleider || role.beheerder)"
              >
                <!-- wijzig einddatum -->
                <XVbootstraprow
                  :label="translation(16847)"
                  :haserror="
                    errors.has('tbxWijzigEindDatum' + tablerow.index) ||
                      isAfter(startdatum(tablerow.row.startDatum), tablerow.row.tableRowState.WijzigDatumSelected)
                  "
                  :errormessage="einddatumErrorMessage(tablerow)"
                >
                  <XVdate
                    :id="'tbxWijzigEindDatum' + tablerow.index"
                    :name="'tbxWijzigEindDatum' + tablerow.index"
                    v-model.trim="tablerow.row.tableRowState.WijzigDatumSelected"
                    :data-vv-as="translation(16847)"
                    v-validate="{ XVDateDefault: true }"
                  ></XVdate>
                </XVbootstraprow>
                <XVbootstraprow
                  id="lblWijzigSchoolvestigingNA"
                  :label="translation(16862)"
                  v-show="tablerow.row.tableRowState.editModus"
                >
                  <XVcheckbox
                    v-model="tablerow.row.tableRowState.cbWijzigSchoolvestigingNA"
                    id="cbWijzigSchoolvestigingNA"
                    :disabled="tablerow.row.tableRowState.wijzigVestigingSelected.length > 0"
                  ></XVcheckbox>
                </XVbootstraprow>
                <!-- Schoolvestiging(en) -->
                <XVbootstraprow
                  :label="translation(16849)"
                  v-show="tablerow.row.tableRowState.editModus"
                  :required="!tablerow.row.tableRowState.cbWijzigSchoolvestigingNA"
                  :haserror="errors.has('msWijzigSchoolvestiging' + tablerow.index)"
                  :errormessage="errors.first('msWijzigSchoolvestiging' + tablerow.index)"
                >
                  <multiselect
                    :id="'msWijzigSchoolvestiging' + tablerow.index"
                    :name="'msWijzigSchoolvestiging' + tablerow.index"
                    v-model="tablerow.row.tableRowState.wijzigVestigingSelected"
                    :options="tablerow.row.tableRowState.vestigingenWijzigData"
                    :placeholder="translation(16850)"
                    label="labelText"
                    track-by="labelText"
                    openDirection="bottom"
                    :disabled="tablerow.row.tableRowState.vestigingenWijzigData.length === 0"
                    :maxHeight="200"
                    :allow-empty="true"
                    v-validate="!tablerow.row.tableRowState.cbWijzigSchoolvestigingNA ? 'required' : ''"
                    :data-vv-as="translation(16849)"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :hide-selected="true"
                    selectLabel
                    @select="
                      setStateSchoolNotInList(tablerow.index, tablerow.row.tableRowState.wijzigVestigingSelected > 0)
                    "
                  >
                    <!-- v-validate="formInput.cbSchoolvestigingNietAanwezig === false ? 'required' : ''" -->
                    <template slot="tag" slot-scope="props">
                      <span class="multiselect__tag">
                        <span>{{ props.option.labelText + ' (' + props.option.value + ')' }}</span>
                        <i
                          aria-hidden="true"
                          tabindex="1"
                          class="multiselect__tag-icon"
                          @click="props.remove(props.option)"
                        ></i>
                      </span>
                    </template>
                    <template slot="option" slot-scope="props">
                      <span>{{ props.option.labelText + ' (' + props.option.value + ')' }}</span>
                    </template>
                    <template slot="noResult"
                      ><span>{{ translation(16851) }}</span></template
                    >
                    <template slot="noOptions"
                      ><span>{{ translation(16851) }}</span></template
                    >
                  </multiselect>
                </XVbootstraprow>
              </div>
              <div
                class="row XVtablebtnwijzigen margin20bottom"
                v-if="tablerow.row.einddatum === '' && (role.schoolleider || role.beheerder)"
              >
                <div class="col-12">
                  <div class="btn-group XVtablerowbtngroup">
                    <button
                      :id="'btnSave' + tablerow.index"
                      type="button"
                      class="btn btn-primary XVtablerowbutton"
                      @click.prevent="btnSave(tablerow)"
                      :disabled="btnToggles.btnWijziging"
                      v-if="tablerow.row.tableRowState.editModus"
                    >
                      <font-awesome-icon :icon="['far', 'save']" />
                      {{ translation(16852) }}
                    </button>
                    <button
                      :id="'btnCancel' + tablerow.index"
                      type="button"
                      class="btn btn-primary XVtablerowbutton"
                      @click.prevent="btnCancel(tablerow.index)"
                      v-if="tablerow.row.tableRowState.editModus"
                    >
                      <font-awesome-icon icon="times" />
                      {{ translation(16853) }}
                    </button>
                  </div>
                  <button
                    :id="'btnWijzig_' + tablerow.index"
                    type="button"
                    class="btn btn-primary XVtablerowbutton"
                    @click.prevent="btnWijzig(tablerow.index)"
                    v-if="
                      !tablerow.row.tableRowState.editModus &&
                        role.schoolleider &&
                        (wXS === true || wSM === true || wMD === true)
                    "
                  >
                    <font-awesome-icon :icon="['far', 'calendar-edit']" />
                    {{ translation(16844) }}
                  </button>
                  <div class="btn-group XVtablerowbtngroup" v-if="role.beheerder">
                    <button
                      :id="'btnWijzig' + tablerow.index"
                      type="button"
                      class="btn btn-primary XVtablerowbutton"
                      @click.prevent="btnWijzig(tablerow.index)"
                      v-if="!tablerow.row.tableRowState.editModus && (wXS === true || wSM === true || wMD === true)"
                    >
                      <font-awesome-icon :icon="['far', 'calendar-edit']" />
                      {{ translation(16844) }}
                    </button>
                    <button
                      :id="'btnVerwijder' + tablerow.index"
                      type="button"
                      class="btn btn-primary XVtablerowbutton"
                      @click.prevent="openConfirmVerwijder(tablerow)"
                      v-if="!tablerow.row.tableRowState.editModus && (wXS === true || wSM === true || wMD === true)"
                    >
                      <font-awesome-icon :icon="['fa', 'trash']" />
                      {{ translation(16845) }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </XVtableV2>
      </div>
    </div>
    <div class="row" v-if="role.bestuurder">
      <div class="col-12">
        <button type="button" id="btnToevoegen" class="btn btn-primary btn-xs" @click.prevent="btnToevoegenConcept">
          <font-awesome-icon icon="plus" />
          {{ translation(16854) }}
        </button>
      </div>
    </div>
    <div class="row" v-if="role.bestuurder">
      <div class="col-12">
        <XVtableV2
          :filterfunc="filterfuncConcepten"
          :tablesetting="srpoTableConcepten.tablesetting"
          :tablecolumnsetting="srpoTableConcepten.tablecolumnsetting"
          :tabledata="srpoTableConcepten.tabledata"
          v-on:sortXVTable="conceptXVTablesort"
          :XVtableSetRowStateProperty="conceptXVtableSetRowStateProperty"
          :tableSearchBox="false"
        >
          <template slot="wijzig" slot-scope="dr">
            <router-link
              :to="{
                name: 'wijzigConcept',
                params: { conceptId: dr.row.id }
              }"
              ><font-awesome-icon :icon="['far', 'edit']" class="initial pointer"
            /></router-link>
          </template>
          <template slot="verwijder" slot-scope="dr">
            <a
              href="#"
              :id="'verwijder_' + [dr.index]"
              @click="openConfirmConceptVerwijder(dr)"
              class="pointer"
              :title="translation(150)"
              ><font-awesome-icon :icon="['fa', 'trash']" class="initial pointer"
            /></a>
          </template>
          <template slot="geregistreerde" slot-scope="dr">
            <span>{{ dr.person }}</span>
          </template>
          <template slot="detailrow" slot-scope="dr">
            <div class="margin20 margin20bottom">
              <div class="row" v-if="wXS || wSM || wMD">
                <div class="col-4 col-sm-12 col-xs-12">
                  <label>{{ translation(16868) }}</label>
                </div>
                <div class="col-8 col-sm-12 col-xs-12 form-group has-feedback">
                  {{ dr.row.email }}
                </div>
              </div>
              <div class="row" v-if="wXS || wSM || wMD">
                <div class="col-4 col-sm-12 col-xs-12">
                  <label>{{ translation(16870) }}</label>
                </div>
                <div class="col-8 col-sm-12 col-xs-12 form-group has-feedback">
                  {{ dr.row.functie }}
                </div>
              </div>
              <div class="row" v-if="wXS || wSM || wMD">
                <div class="col-4 col-sm-12 col-xs-12">
                  <label>{{ translation(16871) }}</label>
                </div>
                <div class="col-8 col-sm-12 col-xs-12 form-group has-feedback">
                  {{ dr.row.startDatum }}
                </div>
              </div>
              <div class="btn-group XVtablerowbtngroup">
                <button
                  :id="'btnWijzigMobile' + dr.index"
                  type="button"
                  class="btn btn-primary XVtablerowbutton"
                  @click.prevent="btnWijzigConceptMobile(dr.row.id)"
                  v-if="wXS === true || wSM === true || wMD === true"
                >
                  <font-awesome-icon :icon="['far', 'calendar-edit']" />
                  {{ translation(16844) }}
                </button>
                <button
                  :id="'btnVerwijderMobile' + dr.index"
                  type="button"
                  class="btn btn-primary XVtablerowbutton"
                  @click.prevent="openConfirmConceptVerwijder(dr)"
                  v-if="wXS === true || wSM === true || wMD === true"
                >
                  <font-awesome-icon :icon="['fa', 'trash']" />
                  {{ translation(16845) }}
                </button>
              </div>
            </div>
          </template>
        </XVtableV2>
      </div>
    </div>
    <modal v-model="pageSettings.showConfirm" title="Modal 1" ref="modal" id="modal-demo" :header="false">
      <p>{{ translation(16855) }}</p>
      <div slot="footer" class="modalconfirmbuttons">
        <button
          id="btnDeleteModal"
          type="button"
          class="btn btn-primary modalconfirmbutton"
          @click.prevent="continueConfirm()"
        >
          {{ translation(16856) }}
        </button>
        <button
          id="btnCloseModal"
          type="button"
          class="btn btn-primary modalconfirmbutton"
          @click.prevent="closeConfirm()"
        >
          {{ translation(16857) }}
        </button>
      </div>
    </modal>
    <!-- modal window verwijder overeenkomst  -->
    <modal
      v-model="pageSettings.showConfirmVerwijder"
      title="Modal 1"
      ref="modalVerwijder"
      id="modal-verwijder"
      :header="false"
    >
      <p>{{ translation(16858) }}</p>
      <div slot="footer" class="modalconfirmbuttons">
        <button
          id="btnDeleteModal"
          type="button"
          class="btn btn-primary modalconfirmbutton"
          @click.prevent="continueConfirmVerwijder()"
        >
          {{ translation(16856) }}
        </button>
        <button
          id="btnCloseModal"
          type="button"
          class="btn btn-primary modalconfirmbutton"
          @click.prevent="closeConfirmVerwijder()"
        >
          {{ translation(16857) }}
        </button>
      </div>
    </modal>
    <!-- modal window verwijder concept overeenkomst  -->
    <modal
      v-model="pageSettings.showConfirmConceptVerwijder"
      title="Modal 1"
      ref="modalConcept"
      id="modal-concept"
      :header="false"
    >
      <p v-html="translation(16859)"></p>
      <div slot="footer" class="modalconfirmbuttons">
        <button
          id="btnDeleteModal"
          type="button"
          class="btn btn-primary modalconfirmbutton"
          @click.prevent="continueConfirmConceptVerwijder()"
        >
          {{ translation(16856) }}
        </button>
        <button
          id="btnCloseModal"
          type="button"
          class="btn btn-primary modalconfirmbutton"
          @click.prevent="closeConfirmConceptVerwijder()"
        >
          {{ translation(16857) }}
        </button>
      </div>
    </modal>
    <div v-if="loading" class="loading-container">
      <XVwaiter></XVwaiter>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import { FAMixin, util } from 'pevueglobal'
import XVwaiter from '../../../components/XVwaiter.vue'
import { isAfter } from 'date-fns'

export default {
  mixins: [FAMixin],
  components: {
    Multiselect,
    XVwaiter
  },
  data: function() {
    return {}
  },
  async mounted() {
    await this.getRole()
    if (this.role.schoolleider || this.role.bestuurder) {
      await this.getTableData()
    }
    if (this.role.bestuurder) {
      await this.getConceptTableData()
    }
  },
  computed: {
    ...mapGetters('SRPOOvereenkomsten', [
      'srpoTable',
      'srpoTableConcepten',
      'pageSettings',
      'role',
      'XVtableGetValue',
      'XVtableGetRowStateProperty',
      'loading',
      'btnToggles',
      'filterInput'
    ]),
    extraInformationTranslationKey() {
      if (this.role.beheerder) {
        return 16895
      } else if (this.role.schoolleider) {
        return 16896
      } else if (this.role.bestuurder) {
        return 16897
      }
      return 1
    },
    filterHasText() {
      return (
        this.filterInput.registered !== '' || this.filterInput.bestuur !== '' || this.filterInput.iBirthDate !== null
      )
    }
  },
  methods: {
    isAfter,
    ...mapActions('SRPOOvereenkomsten', [
      'getTexten',
      'getRole',
      'getTableData',
      'getConceptTableData',
      'getVestigingenWijzig',
      'updateOvereenkomst',
      'deleteOvereenkomst',
      'deleteConceptOvereenkomst',
      'getResetFilters'
    ]),
    ...mapMutations(['addNotification']),
    ...mapMutations('SRPOOvereenkomsten', [
      'XVTablesort',
      'XVtablecolumnsettingchanged',
      'XVtableSetRowStateProperty',
      'conceptXVtableSetRowStateProperty',
      'conceptXVTablesort',
      'showConfirm',
      'showConfirmVerwijder',
      'showConfirmConceptVerwijder',
      'clearDetail',
      'clearDetailConcept',
      'toggleBtnWijziging',
      'toggleBtnVerwijder',
      'toggleBtnVerwijderConcept'
    ]),
    filterResults() {
      this.getTableData()
    },
    setStateSchoolNotInList(index, newSchoolInListState) {
      this.XVtableSetRowStateProperty({
        index: index,
        stateProperty: 'cbWijzigSchoolvestigingNA',
        statePropertyValue: newSchoolInListState
      })
    },
    startdatum(date) {
      return util.parseDate(date)
    },
    resetFilters() {
      this.getResetFilters()
    },
    einddatumErrorMessage(tablerow) {
      if (this.errors.has('tbxWijzigEindDatum' + tablerow.index)) {
        return this.errors.first('tbxWijzigEindDatum' + tablerow.index)
      } else if (isAfter(this.startdatum(tablerow.row.startDatum), tablerow.row.tableRowState.WijzigDatumSelected)) {
        return this.translation(16879)
      } else {
        return ''
      }
    },
    filterfuncConcepten(tabledata) {
      return tabledata
    },
    filterfunc(tabledata) {
      // per rol bepalen welke kolom zichtbaar, op werlk kolom gesorteerd
      if (this.role.schoolleider) {
        this.XVtablecolumnsettingchanged({
          column: 'wijzig',
          visible: 1
        })
        this.XVtablecolumnsettingchanged({
          column: 'verwijder',
          visible: 0
        })
        this.XVtablecolumnsettingchanged({
          column: 'bestuur',
          visible: 1
        })
        this.XVtablecolumnsettingchanged({
          column: 'functie',
          visible: 1
        })
        this.XVtablecolumnsettingchanged({
          column: 'startDatum',
          visible: 1
        })
        // sorteren
        this.XVtablecolumnsettingchanged({
          column: 'einddatum',
          visible: 1,
          sortableDefault: 1
        })
        this.XVtablecolumnsettingchanged({
          column: 'vestiging',
          visible: 1
        })
      } else if (this.role.beheerder) {
        this.XVtablecolumnsettingchanged({
          column: 'wijzig',
          visible: 1
        })
        this.XVtablecolumnsettingchanged({
          column: 'verwijder',
          visible: 1
        })
        this.XVtablecolumnsettingchanged({
          column: 'bestuur',
          visible: 1
        })
        this.XVtablecolumnsettingchanged({
          column: 'person',
          visible: 1
        })
        this.XVtablecolumnsettingchanged({
          column: 'geboortedatum',
          visible: 1
        })
        this.XVtablecolumnsettingchanged({
          column: 'functie',
          visible: 1
        })
        this.XVtablecolumnsettingchanged({
          column: 'startDatum',
          visible: 1
        })
        // sorteren
        this.XVtablecolumnsettingchanged({
          column: 'einddatum',
          visible: 1,
          sortableDefault: 1
        })
        this.XVtablecolumnsettingchanged({
          column: 'vestiging',
          visible: 1
        })
      } else if (this.role.bestuurder) {
        this.XVtablecolumnsettingchanged({
          column: 'wijzig',
          visible: 0
        })
        this.XVtablecolumnsettingchanged({
          column: 'verwijder',
          visible: 0
        })
        this.XVtablecolumnsettingchanged({
          column: 'status',
          visible: 1
        })
        this.XVtablecolumnsettingchanged({
          column: 'herregistratiedatum',
          visible: 1
        })
        // sorteren
        this.XVtablecolumnsettingchanged({
          column: 'person',
          visible: 1,
          sortableDefault: 1
        })
        this.XVtablecolumnsettingchanged({
          column: 'geboortedatum',
          visible: 1
        })
        this.XVtablecolumnsettingchanged({
          column: 'email',
          visible: 1
        })
        this.XVtablecolumnsettingchanged({
          column: 'functie',
          visible: 1
        })
        this.XVtablecolumnsettingchanged({
          column: 'startDatum',
          visible: 1
        })
        this.XVtablecolumnsettingchanged({
          column: 'einddatum',
          visible: 0
        })
        this.XVtablecolumnsettingchanged({
          column: 'vestiging',
          visible: 1
        })
      }
      return tabledata
    },
    btnToevoegen() {
      if (this.pageSettings.actieveOvereenkomst === true) {
        this.showConfirm(true)
      } else {
        this.$router.push({ name: 'toevoegen' })
      }
    },
    btnBericht() {
      this.$router.push({ name: 'bericht' })
    },
    closeConfirm() {
      this.showConfirm(false)
    },
    continueConfirm() {
      this.showConfirm(false)
      this.clearDetail()
      this.$router.push({ name: 'toevoegen' })
    },
    btnToevoegenConcept() {
      this.clearDetailConcept()
      this.$router.push({ name: 'toevoegenConcept' })
    },
    openConfirmVerwijder(tablerow) {
      this.showConfirmVerwijder(true)
      this.pageSettings.selectedOvereenkomstId = tablerow.row.id
    },
    continueConfirmVerwijder() {
      this.showConfirmVerwijder(false)
      this.toggleBtnVerwijder(true)
      this.deleteOvereenkomst(this.pageSettings.selectedOvereenkomstId)
    },
    closeConfirmVerwijder() {
      this.pageSettings.selectedOvereenkomstId = 0
      this.showConfirmVerwijder(false)
    },
    openConfirmConceptVerwijder(tablerow) {
      this.showConfirmConceptVerwijder(true)
      this.pageSettings.selectedConceptOvereenkomstId = tablerow.row.id
    },
    continueConfirmConceptVerwijder() {
      this.showConfirmConceptVerwijder(false)
      this.toggleBtnVerwijderConcept(true)
      this.deleteConceptOvereenkomst(this.pageSettings.selectedConceptOvereenkomstId)
    },
    closeConfirmConceptVerwijder() {
      this.pageSettings.selectedConceptOvereenkomstId = 0
      this.showConfirmConceptVerwijder(false)
    },
    btnWijzigConceptMobile(id) {
      this.$router.push({ name: 'wijzigConcept', params: { conceptId: id } })
    },
    wijzigPersoon(tablerow) {
      const editModus = tablerow.row.tableRowState.editModus
      this.setXVtableAllEditModusFalse()

      // vul multiselect van vestigingen
      this.getVestigingenWijzig(tablerow.row)
      if (!editModus) {
        this.XVtableSetRowStateProperty({
          index: tablerow.index,
          stateProperty: 'rowVisible',
          statePropertyValue: true
        })
        this.XVtableSetRowStateProperty({ index: tablerow.index, stateProperty: 'editModus', statePropertyValue: true })
        let vestigingen = this.XVtableGetValue({ index: tablerow.index, columnname: 'vestiging' })
        this.XVtableSetRowStateProperty({
          index: tablerow.index,
          stateProperty: 'wijzigVestigingSelected',
          statePropertyValue: vestigingen
        })
      } else {
        this.XVtableSetRowStateProperty({
          index: tablerow.index,
          stateProperty: 'rowVisible',
          statePropertyValue: false
        })
        this.XVtableSetRowStateProperty({
          index: tablerow.index,
          stateProperty: 'editModus',
          statePropertyValue: false
        })
        this.XVtableSetRowStateProperty({
          index: tablerow.index,
          stateProperty: 'wijzigVestigingSelected',
          statePropertyValue: []
        })
      }
    },
    setXVtableAllEditModusFalse() {
      this.srpoTable.tabledata.map(row => {
        if (row.tableRowState.editModus) {
          this.XVtableSetRowStateProperty({
            index: row.tableRowState.storeTableindex,
            stateProperty: 'rowVisible',
            statePropertyValue: false
          })
          this.XVtableSetRowStateProperty({
            index: row.tableRowState.storeTableindex,
            stateProperty: 'editModus',
            statePropertyValue: false
          })
        }
      })
    },
    btnWijzig(index) {
      this.XVtableSetRowStateProperty({ index: index, stateProperty: 'rowVisible', statePropertyValue: true })
      this.XVtableSetRowStateProperty({ index: index, stateProperty: 'editModus', statePropertyValue: true })
      let datum = this.XVtableGetValue({ index: index, columnname: 'einddatum' })
      this.XVtableSetRowStateProperty({ index: index, stateProperty: 'WijzigDatumSelected', statePropertyValue: datum })
      let vestigingen = this.XVtableGetValue({ index: index, columnname: 'vestiging' })
      this.XVtableSetRowStateProperty({
        index: index,
        stateProperty: 'wijzigVestigingSelected',
        statePropertyValue: vestigingen
      })
    },
    btnCancel(index) {
      this.XVtableSetRowStateProperty({ index: index, stateProperty: 'WijzigDatumSelected', statePropertyValue: null })
      if (this.wXS || this.wSM) {
        this.XVtableSetRowStateProperty({ index: index, stateProperty: 'rowVisible', statePropertyValue: true })
        this.XVtableSetRowStateProperty({ index: index, stateProperty: 'editModus', statePropertyValue: false })
      } else {
        this.XVtableSetRowStateProperty({ index: index, stateProperty: 'rowVisible', statePropertyValue: false })
        this.XVtableSetRowStateProperty({ index: index, stateProperty: 'editModus', statePropertyValue: false })
      }
    },
    btnSave(tablerow) {
      this.toggleBtnWijziging(true)
      let valEinddatum = tablerow.row.tableRowState.WijzigDatumSelected
      let valStartdatum = util.parseDate(tablerow.row.startDatum)

      // customdateval aangemaakt ivm isAfter errors die niet worden toegevoegd aan de vee-validate errors.
      // ofwel de isAfter ging bijv wel af, maar je kon alsnog opslaan.
      let customdateval = true
      customdateval = !isAfter(valStartdatum, valEinddatum) && customdateval === true
      if (customdateval === true) {
        this.$validator.validate().then(result => {
          if (result) {
            let schoolvestigingenArr = tablerow.row.tableRowState.wijzigVestigingSelected.map(a => a.value)
            let updateString = {
              overeenkomstId: tablerow.row.id,
              eindDatum: util.DateForDatabaseV2(tablerow.row.tableRowState.WijzigDatumSelected),
              vestigingen: schoolvestigingenArr
            }
            this.XVtableSetRowStateProperty({
              index: tablerow.index,
              stateProperty: 'editModus',
              statePropertyValue: false
            })
            this.updateOvereenkomst(updateString)
            this.XVtableSetRowStateProperty({
              index: tablerow.index,
              stateProperty: 'rowVisible',
              statePropertyValue: false
            })
          } else {
            this.toggleBtnWijziging(false)
            this.addNotification({
              groupname: 'warning',
              message: this.translation(14642)
            })
          }
        })
      } else {
        this.toggleBtnWijziging(false)
        this.addNotification({
          groupname: 'warning',
          message: this.translation(14642)
        })
      }
    }
  }
}
</script>

<style scoped>
.multiselect {
  background-color: #fff;
}
</style>
